import * as THREE from "three";
import { BehaviorSubject } from "rxjs";
import { filter } from "rxjs/operators";

class ModelManager {
  constructor(world) {
    this.world = world;

    this.modelDefinitions = {};
    this.modelDefinitions$ = {};

    this.models = {};
    this.models$ = {};
  }

  getModelDefinition(id) {
    return this.modelDefinitions[id];
  }

  setModelDefinition(id, definition) {
    this.modelDefinitions[id] = definition;
    const modelDefinition$ = this.getModelDefinition$(id);
    if (definition) {
      modelDefinition$.next(definition);

      modelDefinition$
        .pipe(filter((definition) => definition.preload))
        // BUG: This will probably case multible subs ...
        .subscribe({
          next: (definition) => {
            this.world.assetManager
              .getAsset$(definition.file.url)
              .pipe(filter((asset) => asset))
              .subscribe((model) => {
                this.setModel(id, model);
              });
          },
        });
    } else {
      delete this.modelDefinitions[id];
      this.completeModelDefinition$(id);
    }
  }

  getModelDefinition$(id) {
    if (!this.modelDefinitions$[id]) {
      this.modelDefinitions$[id] = new BehaviorSubject();
    }
    return this.modelDefinitions$[id];
  }

  completeModelDefinition$(id) {
    if (this.modelDefinitions$[id]) {
      this.modelDefinitions$[id].complete();
      delete this.modelDefinitions$[id];
    }
  }

  getModel(id) {
    return this.models[id];
  }

  setModel(id, model) {
    this.models[id] = model;
    const model$ = this.getModel$(id);
    if (model) {
      model$.next(model);

      const object3Ds = [];

      model.traverse((node) => {
        if (node instanceof THREE.Object3D) {
          object3Ds.push(node);
        }
      });

      // dev note: object3Ds has to looped outside of model.traverse
      // to avoid errors
      object3Ds.forEach((node) => {
        this.world.object3DManager.setObject3D(node.name, node);
        // node?.name?.includes("Trigger") && console.log(node.name)
      });

      // set root Object3D also with model id
      this.world.object3DManager.setObject3D(id, model);
    } else {
      delete this.modelDefinitions[id];
      this.completeModelDefinition$(id);
    }
  }

  getModel$(id) {
    if (!this.models$[id]) {
      this.models$[id] = new BehaviorSubject();
    }
    return this.models$[id];
  }

  completeModel$(id) {
    if (!this.model$[id]) {
      this.model$[id].complete();
      delete this.model$[id];
    }
  }
}

export default ModelManager;
